export class AnalyticsColumn {
    id:string;
    name:string;
    visible:boolean;
    type:string;
}
